$(document).ready(function () {

    // Function to sort list items by last name
    function sortItems() {
        var items = $('.makers-grid-item-listing li').toArray().sort(function (a, b) {
            var lastNameA = $(a).data('makers-name').split(' ').pop();
            var lastNameB = $(b).data('makers-name').split(' ').pop();
            return lastNameA.localeCompare(lastNameB);
        });
        $('.makers-grid-item-listing').empty().append(items);
    }

    // Initial sort on page load
    sortItems();

    if ($(".name-sorting-filter").length > 0) {
        console.log("Makers Filter based on last names...");
        $('.name-sorting-filter li').on('click', function () {
            $('.name-sorting-filter li').removeClass("active");
            $(this).addClass("active");
            var letter = $(this).attr('data-letter').toUpperCase();
            console.log("letter - " + letter);

            // Filter and sort based on last name
            if (letter === 'ALL') {
                $('.makers-grid-item-listing li').show();
            } else {
                $('.makers-grid-item-listing li').each(function () {
                    var lastName = $(this).data('makers-name').split(' ').pop().charAt(0).toUpperCase();
                    if (lastName === letter) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            }

            // Sort remaining visible items by last name
            sortItems();

            // Handling the visibility of a no data message
            var visibleCount = $('.makers-grid-item-listing li:visible').length;
            if (visibleCount === 0) {
                console.log("No data found!");
                if($(".hidden-count-display").length === 0){
                    $(".makers-grid-item-listing").before('<p class="hidden-count-display">No Makers Found</p>');
                }
            } else {
                $(".hidden-count-display").remove();
            }
        });

        // Clear the filter
        $(".view-all-filter").click(function(){
            $('.name-sorting-filter li').removeClass("active");
            $('.makers-grid-item-listing li').show();
            sortItems();
            $(".hidden-count-display").remove();
        });
    }
});
